export const testimonials = [
  {
    id: 't-1',
    name: '张伟',
    role: '小型制造企业老板',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20businessman%20portrait%2C%20middle%20aged%20man%20in%20casual%20business%20attire%2C%20friendly%20confident%20expression%2C%20clean%20studio%20background%2C%20warm%20lighting%2C%20professional%20headshot&width=100&height=100&seq=avatar-zhang-01&orientation=squarish',
    content: '以前觉得建网站至少要花几千块，没想到用这个免费在线成网站平台，半小时就搞定了。模板很专业，客户都说我们公司看起来大了不少！',
    rating: 5,
    company: '伟业五金制品有限公司',
  },
  {
    id: 't-2',
    name: '李婷',
    role: '独立设计师',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20woman%20portrait%2C%20creative%20designer%20in%20modern%20attire%2C%20confident%20friendly%20smile%2C%20clean%20studio%20background%2C%20warm%20natural%20lighting%2C%20professional%20headshot&width=100&height=100&seq=avatar-li-02&orientation=squarish',
    content: '作为一个设计师，我对网站的美观度要求很高。这个平台的模板设计感真的很棒，完全免费而且导出很方便。现在客户都是通过作品集网站找上门的！',
    rating: 5,
    company: 'TING Design Studio',
  },
  {
    id: 't-3',
    name: '王大伟',
    role: '餐饮连锁店老板',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20restaurant%20owner%20portrait%2C%20middle%20aged%20man%20with%20warm%20smile%2C%20casual%20professional%20attire%2C%20clean%20studio%20background%2C%20warm%20lighting%2C%20friendly%20expression&width=100&height=100&seq=avatar-wang-03&orientation=squarish',
    content: '之前一直靠外卖平台，抽成太高了。用这个平台建了自己的官网后，老顾客都直接在官网下单，利润明显提高了。真心推荐！',
    rating: 5,
    company: '大伟面馆连锁',
  },
  {
    id: 't-4',
    name: '陈小明',
    role: '个人博主',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%2C%20creative%20content%20creator%2C%20casual%20modern%20style%2C%20friendly%20expression%2C%20clean%20studio%20background%2C%20warm%20natural%20lighting%2C%20professional%20headshot&width=100&height=100&seq=avatar-chen-04&orientation=squarish',
    content: '从零开始写博客，什么都不懂。这个平台真的做到了零门槛，现在我的博客已经有一万多粉丝了。SEO功能特别给力，文章在百度排名都不错！',
    rating: 5,
    company: '小明的技术笔记',
  },
];